import { Routes } from '@angular/router';
import { ProjectsComponent } from './features/projects/projects';
import { ImportComponent } from './features/import/import';
import { EditorComponent } from './features/editor/editor';
import { CampaignsComponent } from './features/campaigns/campaigns';
import { authGuard } from './core/guards/auth.guard';
import { homeGuard } from './core/guards/home.guard';
import { companyAccessGuard } from './core/guards/company-access.guard';
import { unsavedChangesGuard } from './core/guards/unsaved-changes.guard';

export const routes: Routes = [
	{ path: '', pathMatch: 'full', canActivate: [homeGuard], children: [] },
	{ path: 'login', loadComponent: () => import('./features/login/login').then(m => m.LoginComponent) },

	// Admin
	{ path: 'admin', loadComponent: () => import('./features/admin/admin').then(m => m.AdminComponent), canActivate: [authGuard] },
	{
		path: 'admin/import-catalog',
		loadComponent: () => import('./features/admin/import-catalog/import-catalog').then(m => m.ImportCatalogComponent),
		canActivate: [authGuard],
	},

	// User profile (change password)
	{ path: 'profile', loadComponent: () => import('./features/profile/profile').then(m => m.ProfileComponent), canActivate: [authGuard] },

	// Company-scoped routes
	{ path: ':companySlug/campaigns', component: CampaignsComponent, canActivate: [authGuard, companyAccessGuard] },
	{ path: ':companySlug/campaigns/:campaignSlug', component: ProjectsComponent, canActivate: [authGuard, companyAccessGuard] },
	{ path: ':companySlug/campaigns/:campaignSlug/import', component: ImportComponent, canActivate: [authGuard, companyAccessGuard] },
	{ path: ':companySlug/campaigns/:campaignSlug/create', component: ImportComponent, canActivate: [authGuard, companyAccessGuard] },
	{ path: ':companySlug/campaigns/:campaignSlug/:id/editor', component: EditorComponent, canActivate: [authGuard, companyAccessGuard], canDeactivate: [unsavedChangesGuard] },
	{
		path: ':companySlug/campaigns/:campaignSlug/:id/publisher',
		loadComponent: () => import('./features/publisher/publisher').then(m => m.PublisherComponent),
		canActivate: [authGuard, companyAccessGuard],
	},
	{ path: ':companySlug/editor/:id', component: EditorComponent, canActivate: [authGuard, companyAccessGuard], canDeactivate: [unsavedChangesGuard] },

	// Wildcard: re-uses homeGuard which redirects logged-in users to their default
	// company campaigns and unauthenticated users to /login.
	{ path: '**', canActivate: [homeGuard], children: [] },
];
